<template>
  <div class="search-input">
    <input
      type="text"
      v-model="query"
      :placeholder="placeHolder || 'search...'"
    />
    <icon size="18">search</icon>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    placeHolder: String,
  },
  computed: {
    query: {
      get() {
        return this.value;
      },
      set(value) {
        return this.$emit("input", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.search-input {
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;

  input {
    background: transparent;
    min-width: 250px;
    max-width: 300px;
    background: var(--color-default-background);
    border: 1px solid var(--border-color);
    border-radius: 5px;
    padding-left: 40px;

    &:hover,
    &:focus {
      border-color: var(--color-accent);
    }
  }

  i {
    position: absolute;
    padding-left: 10px;
  }
}
</style>
